import React, { useEffect, useState } from 'react';
import { Anchor, Box, DataTable, Heading, Pagination } from 'grommet';
import QueryString from 'qs';
import { API, Utils } from '@enrich/shared-lib';

export const SchoolReporting = () => {
    const stepOptions = [25, 50, 100];
    const [schools, setSchools] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(stepOptions[0]);

    useEffect(() => {
        if (!page) return;
        let isActive = true;

        (async () => {
            const schoolsResponse = await loadSchools({ page, pageSize });

            if (isActive) {
                setPage(schoolsResponse.meta.pagination.page);
                setSchools(Utils.deepFlatten(schoolsResponse.data));
                setTotalItems(schoolsResponse.meta.pagination.total);
            }
        })();

        return () => {
            isActive = false;
        };
    }, [page, pageSize]);

    const handlePageChange = ({ page, startIndex, endIndex }) => {
        const newPageSize = endIndex - startIndex;
        if (pageSize != newPageSize) {
            setPageSize(newPageSize);
        }
        setPage(page);
    };

    const dataColumns = [
        {
            header: 'Name',
            property: 'name',
            render: (school) => {
                return (
                    <Anchor
                        key={school.id}
                        href={`/schools/${school.id}`}
                        label={school.name}
                    />
                );
            },
            sortable: true,
        },
    ];

    return (
        <Box>
            <Heading level="3">Schools</Heading>
            <DataTable
                primaryKey="id"
                sortable
                border="bottom"
                data={schools}
                columns={dataColumns}
            />
            <Box align="center" justify="center" pad="small">
                <Pagination
                    numberItems={totalItems}
                    onChange={({ page, startIndex, endIndex }) => {
                        handlePageChange({
                            page,
                            startIndex,
                            endIndex,
                        });
                    }}
                    step={pageSize}
                    stepOptions={stepOptions}
                    summary={true}
                />
            </Box>
        </Box>
    );
};

const loadSchools = async ({ page, pageSize } = {}) => {
    const query = QueryString.stringify({
        filters: {
            isReportClient: true,
        },
        pagination: page && pageSize ? { page, pageSize } : undefined,
        sort: ['updatedAt:desc'],
    });

    try {
        const response = await API.get(`/api/schools?${query}`);
        return response.data;
    } catch (error) {
        console.log(error);
    }

    return [];
};
